// removed by extract-text-webpack-plugin
module.exports = {"root":"src-components-Header----styles-module---root---3QZkY"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/styles.module.css
// module id = 296
// module chunks = 132339944140454